export enum TipoSolapaRefacturacion {
  HistorialRefacturacion = 0,
  SeguimientoRefacturacion = 1  
}